import { UserComponent } from '@craftjs/core';
import { FormFieldProps } from './BaseControlTypes';
import { createId } from 'src/helpers/typeUtils';

export const ALLOWED_EXTENSIONS = [
  '.txt',
  '.pdf',
  '.doc',
  '.jpeg',
  '.jpg',
  '.zip',
  '.7z',
  '.png',
  '.xlsx',
  '.xlx',
  '.docx',
  '.csv',
  '.json',
  '.pdat',
  '.psdat',
  '.pvdat',
  '.ldat',
] as const;
export type AllowedExtensionsType = (typeof ALLOWED_EXTENSIONS)[number];

export type FormFileInputProps = FormFieldProps & {
  isMultiple?: boolean;
  fileTypes?: AllowedExtensionsType[];
  addFileButtonText: string;
  maxFileSizeMb?: number;
};

export const formFileInputDefaultProps: FormFileInputProps = {
  dataKey: createId(),
  title: 'File',
  addFileButtonText: 'Attach a file',
  fileTypes: ['.txt'],
};

export type FormFileInputComponent = UserComponent<FormFileInputProps>;
